// Join class names, dropping falsy entries. Keeps conditional Tailwind classes
// readable without pulling in a dependency.
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

// Analytics is best-effort: the umami script may be blocked or fail to load, so
// every call is guarded (mirrors the guard the old inline scripts used).
declare global {
  interface Window {
    umami?: { track: (event: string, data?: Record<string, unknown>) => void };
  }
}

export function track(event: string, data?: Record<string, unknown>): void {
  try {
    window.umami?.track(event, data);
  } catch {
    // Analytics must never break a feature.
  }
}
